// src/data/svns/bordeaux/matches2026SvnsBordeaux.ts

import type {
  MatchData,
} from "../../matches/types";

export const matches2026SvnsBordeaux: MatchData[] = [
 {
  id: 30001,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "A",
  date: "2026-06-05T09:05:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "New Zealand",
    country: "New Zealand",
  },
  away: {
    name: "Argentina",
    country: "Argentina",
  },
  state: "final",
  score: {
    home: 49,
    away: 5,
  },
},

{
  id: 30002,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "B",
  date: "2026-06-05T09:28:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Australia",
    country: "Australia",
  },
  away: {
    name: "Brazil",
    country: "Brazil",
  },
  state: "final",
  score: {
    home: 45,
    away: 7,
  },
},

{
  id: 30003,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "C",
  date: "2026-06-05T09:51:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "USA",
    country: "USA",
  },
  away: {
    name: "Great Britain",
    country: "Great Britain",
  },
  state: "final",
  score: {
    home: 31,
    away: 7,
  },
},

{
  id: 30004,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "A",
  date: "2026-06-05T10:14:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "France",
    country: "France",
  },
  away: {
    name: "South Africa",
    country: "South Africa",
  },
  state: "final",
  score: {
    home: 22,
    away: 7,
  },
},

{
  id: 30005,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "B",
  date: "2026-06-05T10:37:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Japan",
    country: "Japan",
  },
  away: {
    name: "Fiji",
    country: "Fiji",
  },
  state: "final",
  score: {
    home: 12,
    away: 24,
  },
},

{
  id: 30006,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "C",
  date: "2026-06-05T11:00:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Canada",
    country: "Canada",
  },
  away: {
    name: "Spain",
    country: "Spain",
  },
  state: "final",
  score: {
    home: 14,
    away: 12,
  },
},

{
  id: 30007,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "A",
  date: "2026-06-05T13:41:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "New Zealand",
    country: "New Zealand",
  },
  away: {
    name: "South Africa",
    country: "South Africa",
  },
  state: "final",
  score: {
    home: 42,
    away: 0,
  },
},

{
  id: 30008,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "B",
  date: "2026-06-05T14:04:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Australia",
    country: "Australia",
  },
  away: {
    name: "Fiji",
    country: "Fiji",
  },
  state: "final",
  score: {
    home: 19,
    away: 7,
  },
},

{
  id: 30009,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "C",
  date: "2026-06-05T14:27:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "USA",
    country: "USA",
  },
  away: {
    name: "Spain",
    country: "Spain",
  },
  state: "final",
  score: {
    home: 19,
    away: 15,
  },
},

{
  id: 30010,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "A",
  date: "2026-06-05T14:50:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "France",
    country: "France",
  },
  away: {
    name: "Argentina",
    country: "Argentina",
  },
  state: "final",
  score: {
    home: 27,
    away: 10,
  },
},

{
  id: 30011,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "B",
  date: "2026-06-05T15:13:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Japan",
    country: "Japan",
  },
  away: {
    name: "Brazil",
    country: "Brazil",
  },
  state: "final",
  score: {
    home: 29,
    away: 14,
  },
},

{
  id: 30012,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "C",
  date: "2026-06-05T15:36:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Canada",
    country: "Canada",
  },
  away: {
    name: "Great Britain",
    country: "Great Britain",
  },
  state: "final",
  score: {
    home: 35,
    away: 14,
  },
},

/* ==================================================
   MEN DAY 1
   ================================================== */

{
  id: 30013,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "A",
  date: "2026-06-05T11:23:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "South Africa",
    country: "South Africa",
  },
  away: {
    name: "Kenya",
    country: "Kenya",
  },
  state: "final",
  score: {
    home: 26,
    away: 5,
  },
},

{
  id: 30014,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "B",
  date: "2026-06-05T11:46:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Australia",
    country: "Australia",
  },
  away: {
    name: "Uruguay",
    country: "Uruguay",
  },
  state: "final",
  score: {
    home: 43,
    away: 12,
  },
},

{
  id: 30015,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "C",
  date: "2026-06-05T12:09:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Argentina",
    country: "Argentina",
  },
  away: {
    name: "Germany",
    country: "Germany",
  },
  state: "final",
  score: {
    home: 35,
    away: 19,
  },
},

{
  id: 30016,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "A",
  date: "2026-06-05T12:32:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Fiji",
    country: "Fiji",
  },
  away: {
    name: "Great Britain",
    country: "Great Britain",
  },
  state: "final",
  score: {
    home: 26,
    away: 12,
  },
},

{
  id: 30017,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "B",
  date: "2026-06-05T12:55:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Spain",
    country: "Spain",
  },
  away: {
    name: "USA",
    country: "USA",
  },
  state: "final",
  score: {
    home: 19,
    away: 24,
  },
},

{
  id: 30018,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "C",
  date: "2026-06-05T13:18:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "New Zealand",
    country: "New Zealand",
  },
  away: {
    name: "France",
    country: "France",
  },
  state: "final",
  score: {
    home: 26,
    away: 21,
  },
},

{
  id: 30019,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "A",
  date: "2026-06-05T15:59:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "South Africa",
    country: "South Africa",
  },
  away: {
    name: "Great Britain",
    country: "Great Britain",
  },
  state: "final",
  score: {
    home: 14,
    away: 19,
  },
},

{
  id: 30020,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "B",
  date: "2026-06-05T16:22:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Australia",
    country: "Australia",
  },
  away: {
    name: "USA",
    country: "USA",
  },
  state: "final",
  score: {
    home: 17,
    away: 19,
  },
},

{
  id: 30021,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "C",
  date: "2026-06-05T16:45:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Argentina",
    country: "Argentina",
  },
  away: {
    name: "France",
    country: "France",
  },
  state: "final",
  score: {
    home: 14,
    away: 22,
  },
},

{
  id: 30022,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "A",
  date: "2026-06-05T17:08:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Fiji",
    country: "Fiji",
  },
  away: {
    name: "Kenya",
    country: "Kenya",
  },
  state: "final",
  score: {
    home: 31,
    away: 12,
  },
},

{
  id: 30023,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "B",
  date: "2026-06-05T17:31:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Spain",
    country: "Spain",
  },
  away: {
    name: "Uruguay",
    country: "Uruguay",
  },
  state: "final",
  score: {
    home: 42,
    away: 17,
  },
},

{
  id: 30024,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "men",
  round: "pool",
  pool: "C",
  date: "2026-06-05T17:54:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "New Zealand",
    country: "New Zealand",
  },
  away: {
    name: "Germany",
    country: "Germany",
  },
  state: "final",
  score: {
    home: 33,
    away: 7,
  },
},
/* ==================================================
   WOMEN DAY 2
   FINAL POOL MATCHES
   ================================================== */

{
  id: 30025,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "A",
  date: "2026-06-06T09:00:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "New Zealand",
    country: "New Zealand",
  },
  away: {
    name: "France",
    country: "France",
  },
  state: "upcoming",
},

{
  id: 30026,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "A",
  date: "2026-06-06T09:00:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "South Africa",
    country: "South Africa",
  },
  away: {
    name: "Argentina",
    country: "Argentina",
  },
  state: "final",
  score: {
    home: 19,
    away: 12,
  },
},

{
  id: 30027,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "B",
  date: "2026-06-06T09:23:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Australia",
    country: "Australia",
  },
  away: {
    name: "Japan",
    country: "Japan",
  },
  state: "upcoming",
},

{
  id: 30028,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "B",
  date: "2026-06-06T09:23:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Fiji",
    country: "Fiji",
  },
  away: {
    name: "Brazil",
    country: "Brazil",
  },
  state: "upcoming",
},

{
  id: 30029,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "C",
  date: "2026-06-06T09:46:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "USA",
    country: "USA",
  },
  away: {
    name: "Canada",
    country: "Canada",
  },
  state: "upcoming",
},

{
  id: 30030,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "pool",
  pool: "C",
  date: "2026-06-06T09:46:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Spain",
    country: "Spain",
  },
  away: {
    name: "Great Britain",
    country: "Great Britain",
  },
  state: "upcoming",
},

/* ==================================================
   MEN DAY 2
   FINAL POOL MATCHES
   ================================================== */

/* ==================================================
   MEN DAY 2
   FINAL POOL MATCHES
   ================================================== */

{
  id: 30031,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "pool",

  pool: "A",

  date: "2026-06-06T10:09:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "South Africa",
    country: "South Africa",
  },

  away: {
    name: "Fiji",
    country: "Fiji",
  },

  state: "final",

  score: {
    home: 12,
    away: 15,
  },
},

{
  id: 30032,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "pool",

  pool: "A",

  date: "2026-06-06T10:09:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "Kenya",
    country: "Kenya",
  },

  away: {
    name: "Great Britain",
    country: "Great Britain",
  },

  state: "final",

  score: {
    home: 5,
    away: 14,
  },
},

{
  id: 30033,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "pool",

  pool: "B",

  date: "2026-06-06T10:32:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "Australia",
    country: "Australia",
  },

  away: {
    name: "Spain",
    country: "Spain",
  },

  state: "final",

  score: {
    home: 12,
    away: 10,
  },
},

{
  id: 30034,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "pool",

  pool: "B",

  date: "2026-06-06T10:32:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "USA",
    country: "USA",
  },

  away: {
    name: "Uruguay",
    country: "Uruguay",
  },

  state: "final",

  score: {
    home: 43,
    away: 7,
  },
},

{
  id: 30035,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "pool",

  pool: "C",

  date: "2026-06-06T10:55:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "Argentina",
    country: "Argentina",
  },

  away: {
    name: "New Zealand",
    country: "New Zealand",
  },

  state: "final",

  score: {
    home: 21,
    away: 24,
  },
},

{
  id: 30036,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "pool",

  pool: "C",

  date: "2026-06-06T10:55:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "France",
    country: "France",
  },

  away: {
    name: "Germany",
    country: "Germany",
  },

  state: "final",

  score: {
    home: 14,
    away: 7,
  },
},

/* ==================================================
   WOMEN QUARTER FINALS
   ================================================== */

{
  id: 30037,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "quarter-final",
  date: "2026-06-06T12:04:00",
  venue: "Stade Atlantique Bordeaux Métropole",

  home: { name: "Canada", country: "Canada" },
  away: { name: "Fiji", country: "Fiji" },

  score: {
    home: 29,
    away: 14,
  },

  state: "final",
},

{
  id: 30038,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "quarter-final",
  date: "2026-06-06T12:27:00",
  venue: "Stade Atlantique Bordeaux Métropole",

  home: { name: "New Zealand", country: "New Zealand" },
  away: { name: "Japan", country: "Japan" },

  score: {
    home: 35,
    away: 22,
  },

  state: "final",
},

{
  id: 30039,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "quarter-final",
  date: "2026-06-06T12:50:00",
  venue: "Stade Atlantique Bordeaux Métropole",

  home: { name: "USA", country: "USA" },
  away: { name: "France", country: "France" },

  score: {
    home: 12,
    away: 0,
  },

  state: "final",
},

{
  id: 30040,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "quarter-final",
  date: "2026-06-06T13:13:00",
  venue: "Stade Atlantique Bordeaux Métropole",

  home: { name: "Australia", country: "Australia" },
  away: { name: "Spain", country: "Spain" },

  score: {
    home: 14,
    away: 0,
  },

  state: "final",
},
/* ==================================================
   MEN QUARTER FINALS
   ================================================== */

{
  id: 30041,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "quarter-final",

  date: "2026-06-06T14:22:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "Australia",
    country: "Australia",
  },

  away: {
    name: "France",
    country: "France",
  },

  state: "final",

  score: {
    home: 0,
    away: 26,
  },
},

{
  id: 30042,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "quarter-final",

  date: "2026-06-06T14:45:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "Fiji",
    country: "Fiji",
  },

  away: {
    name: "South Africa",
    country: "South Africa",
  },

  state: "final",

  score: {
    home: 12,
    away: 14,
  },
},

{
  id: 30043,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "quarter-final",

  date: "2026-06-06T15:08:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "New Zealand",
    country: "New Zealand",
  },

  away: {
    name: "Great Britain",
    country: "Great Britain",
  },

  state: "final",

  score: {
    home: 24,
    away: 5,
  },
},

{
  id: 30044,

  competitionId: "svns",

  tournament: "HSBC SVNS World Championship",

  tournamentInstanceId:
    "svns-bordeaux-2026",

  stage: "bordeaux",

  gender: "men",

  round: "quarter-final",

  date: "2026-06-06T15:31:00",

  venue:
    "Stade Atlantique Bordeaux Métropole",

  home: {
    name: "USA",
    country: "USA",
  },

  away: {
    name: "Spain",
    country: "Spain",
  },

  state: "final",

  score: {
    home: 5,
    away: 17,
  },
},

/* ==================================================
   WOMEN FINALS DAY
   ================================================== */

 {
  id: 30045,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "11th-place-playoff",
  date: "2026-06-07T09:00:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: { name: "Brazil", country: "Brazil" },
  away: { name: "South Africa", country: "South Africa" },
  score: { home: 24, away: 17 },
  state: "final",
},

{
  id: 30046,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "9th-place-playoff",
  date: "2026-06-07T09:23:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: { name: "Great Britain", country: "Great Britain" },
  away: { name: "Argentina", country: "Argentina" },
  score: { home: 19, away: 31 },
  state: "final",
},

{
  id: 30047,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "7th-place-playoff",
  date: "2026-06-07T09:46:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: { name: "Spain", country: "Spain" },
  away: { name: "Japan", country: "Japan" },
  score: { home: 7, away: 19 },
  state: "final",
},

{
  id: 30048,
  competitionId: "svns",
  tournament: "HSBC SVNS World Championship",
  tournamentInstanceId: "svns-bordeaux-2026",
  stage: "bordeaux",
  gender: "women",
  round: "5th-place-playoff",
  date: "2026-06-07T10:09:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: { name: "Fiji", country: "Fiji" },
  away: { name: "France", country: "France" },
  score: { home: 12, away: 24 },
  state: "final",
},

/* ==================================================
   MEN FINALS DAY
   ================================================== */

{
  id: 30049,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "semi-final",
  date: "2026-06-07T10:32:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "USA",
    country: "USA",
  },
  away: {
    name: "Australia",
    country: "Australia",
  },
  score: {
    home: 7,
    away: 21,
  },
  state: "final",
},

{
  id: 30050,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "semi-final",
  date: "2026-06-07T10:55:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Canada",
    country: "Canada",
  },
  away: {
    name: "New Zealand",
    country: "New Zealand",
  },
  score: {
    home: 17,
    away: 19,
  },
  state: "final",
},

{
  id: 30051,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "bronze-final",
  date: "2026-06-07T12:14:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Canada",
    country: "Canada",
  },
  away: {
    name: "USA",
    country: "USA",
  },
  score: {
    home: 21,
    away: 19,
  },
  state: "final",
},

{
  id: 30052,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "women",
  round: "final",
  date: "2026-06-07T13:00:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "Australia",
    country: "Australia",
  },
  away: {
    name: "New Zealand",
    country: "New Zealand",
  },
  score: {
    home: 26,
    away: 19,
  },
  state: "final",
},

{
  id: 30053,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "men",
  round: "semi-final",
  date: "2026-06-07T11:18:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "France",
    country: "France",
  },
  away: {
    name: "South Africa",
    country: "South Africa",
  },
  score: {
    home: 21,
    away: 12,
  },
  state: "final",
},

{
  id: 30054,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "men",
  round: "semi-final",
  date: "2026-06-07T11:41:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "New Zealand",
    country: "New Zealand",
  },
  away: {
    name: "Spain",
    country: "Spain",
  },
  score: {
    home: 24,
    away: 12,
  },
  state: "final",
},

{
  id: 30055,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "men",
  round: "bronze-final",
  date: "2026-06-07T12:37:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "South Africa",
    country: "South Africa",
  },
  away: {
    name: "Spain",
    country: "Spain",
  },
  score: {
    home: 14,
    away: 40,
  },
  state: "final",
},

{
  id: 30056,
  competitionId: "svns",
  tournamentInstanceId: "svns-bordeaux-2026",
  tournament: "HSBC SVNS World Championship",
  stage: "bordeaux",
  gender: "men",
  round: "final",
  date: "2026-06-07T13:30:00",
  venue: "Stade Atlantique Bordeaux Métropole",
  home: {
    name: "France",
    country: "France",
  },
  away: {
    name: "New Zealand",
    country: "New Zealand",
  },
  score: {
    home: 14,
    away: 5,
  },
  state: "final",
},
];